import { IntlShape } from 'react-intl';

import { Currency } from '../types/currency';
import { OtcAvailability } from './checkOtcAvailability';

interface OtcAvailabilityMessage {
  content: string;
}

function formatCurrencyAmount(
  value: string,
  currency: Currency,
  intl: IntlShape
): string {
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return `${currency} ${intl.formatNumber(num, { maximumFractionDigits: 0 })}`;
}

export function getOtcAvailabilityMessage(
  otcAvailability: OtcAvailability,
  currency: Currency,
  intl: IntlShape
): OtcAvailabilityMessage | null {
  if (!otcAvailability.reason) {
    return null;
  }

  switch (otcAvailability.reason) {
    case 'below_minimum_amount': {
      const minAmount = formatCurrencyAmount(
        otcAvailability.minOtcAmount ?? '0',
        currency,
        intl
      );

      return {
        content: intl.formatMessage(
          { id: 'loanType.otc.availableFromHigherAmount' },
          { minAmount }
        ),
      };
    }
    default:
      return null;
  }
}
